var Vendd = (function (Vendd) {
    'use strict';

    Vendd.InlineAdmin = (function (InlineAdmin) {

        InlineAdmin.Messages = (function (Messages) {

            Messages.CreateCookieForInlineAdmin = function (renderInline, username, password, redirectUrl) {
                var data = {
                    renderInline: renderInline,
                    username: username,
                    password: password,
                    redirectUrl: redirectUrl
                };
                Vendd.MessageBus.VenddMessage.call(this, "Vendd.InlineAdmin.Messages.CreateCookieForInlineAdmin", data);
            }
            Messages.CreateCookieForInlineAdmin.className = "Vendd.InlineAdmin.Messages.CreateCookieForInlineAdmin";

            Messages.CreateCookieForInlineAdminSuccess = function (model, redirectUrl) {
                var data = {
                    model: model,
                    redirectUrl: redirectUrl
                };
                Vendd.MessageBus.VenddMessage.call(this, "Vendd.InlineAdmin.Messages.CreateCookieForInlineAdminSuccess", data);
            }
            Messages.CreateCookieForInlineAdminSuccess.className = "Vendd.InlineAdmin.Messages.CreateCookieForInlineAdminSuccess";

            Messages.CreateCookieForInlineAdminFailure = function (model) {
                var data = {
                    model: model
                };
                Vendd.MessageBus.VenddMessage.call(this, "Vendd.InlineAdmin.Messages.CreateCookieForInlineAdminFailure", data);
            }
            Messages.CreateCookieForInlineAdminFailure.className = "Vendd.InlineAdmin.Messages.CreateCookieForInlineAdminFailure";


            Messages.CheckForInlineAdmin = function (requestNewGuest) {
                var data = {
                    RequestNewGuest: requestNewGuest
                };
                Vendd.MessageBus.VenddMessage.call(this, "Vendd.InlineAdmin.Messages.CheckForInlineAdmin", data);
            }
            Messages.CheckForInlineAdmin.className = "Vendd.InlineAdmin.Messages.CheckForInlineAdmin";

            Messages.CheckForInlineAdminSuccess = function (model) {
                var data = {
                    model: model
                };
                Vendd.MessageBus.VenddMessage.call(this, "Vendd.InlineAdmin.Messages.CheckForInlineAdminSuccess", data);
            }
            Messages.CheckForInlineAdminSuccess.className = "Vendd.InlineAdmin.Messages.CheckForInlineAdminSuccess";

            Messages.CheckForInlineAdminFailure = function (model) {
                var data = {
                    model: model
                };
                Vendd.MessageBus.VenddMessage.call(this, "Vendd.InlineAdmin.Messages.CheckForInlineAdminFailure", data);
            }
            Messages.CheckForInlineAdminFailure.className = "Vendd.InlineAdmin.Messages.CheckForInlineAdminFailure";


            return Messages;

        })(InlineAdmin.Messages || {});

        return InlineAdmin;

    })(Vendd.InlineAdmin || {});

    return Vendd;

})(Vendd || {});
